import React, { useEffect, useRef, useState } from "react";
import EditIcon from "../../../assets/icons/EditIcon";
import {
  Container,
  IconDiv,
  LogoZaivu,
  ProjectName,
  VerticalLine,
  Input,
  ContentName,
} from "./styles";
import LogoZaivuWhite from "../../../assets/Logo-Zaivu-White.svg";
import DropSelect from "./DropSelect";
import PushBackIcon from "../../../assets/icons/PushBackIcon";
import { useOutsideDrop } from "../../../hooks/useOutsideDrop";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAllFlowsTitleNames } from "../../../state/flows/selectors";
import { toastAlert } from "../../Toastify/index";
import { handleRenameFlow } from "../../../state/flows/actions";

const DropSelectVersion = ({
  editable = true,
  loadflow,
  title = "",
  setTitle,
  setCritical,
  state = "creation",
  AdvancedStats = false,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const clearInput = () => setOpen(false);
  const history = useHistory();

  const flow = useSelector((state) => state.flows.pane.flow);
  const status = useSelector((state) => state.flows.pane.status);
  const allflowsTitles = useSelector((state) => getAllFlowsTitleNames(state));

  const dispatch = useDispatch();
  const current = flow.current;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") setOpen(false);
  };

  useOutsideDrop(wrapperRef, clearInput);

  const pushBackStyle = {
    height: "1.75rem",
    width: "1.75rem",
    marginLeft: "1.2rem",
    cursor: "pointer",
  };

  function VersionException(errorMsg) {
    toastAlert({ msg: `${errorMsg}`, isError: true });
    this.message = `Error Exception: ${errorMsg}`;
  }

  const handleTitleValidation = () => {
    try {
      const findNameVersion = allflowsTitles
        .filter((item) => item.title !== current.title)
        .find((item) => item.title === title);

      //Está filtrando somente versões
      if (findNameVersion) {
        setTitle(current.title);
        throw new VersionException(
          `ERRO: Todas as versões devem ter nomes distintos!`
        );
      } else {
        handleRename();
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleRename = () => {
    dispatch(
      handleRenameFlow({
        title,
        flowId: flow.current._id,
        parentId: flow.main._id,
      })
    )
      .then((res) => {
        const title = res.payload?.flow.title;
        toastAlert({
          msg: `Fluxo  '${title}'  RENOMEADO com Sucesso!`,
        });
      })
      .catch((err) => {
        toastAlert({
          msg: `ERRO ao renomear o fluxo '${title}': ${err} `,
          isError: true,
        });
        console.error(err);
      });
  };

  const updateTitle = async () => {
    const isChangedTitle =
      title !== current.title && title !== '' && !open && status === "succeeded";

    if (isChangedTitle) {
      handleTitleValidation();
    }
  };

  useEffect(() => {
    if (current.title) {
      updateTitle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
      <Container>
        <PushBackIcon onClick={() => history.goBack()} style={pushBackStyle} />
        <LogoZaivu
          src={LogoZaivuWhite}
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/")}
        />

        <ContentName>
          <ProjectName openInput={open} AdvancedStats>
            {!open ? (
              <>
                {AdvancedStats ? (
                  <>
                    <p className="uniqueText">Estatisticas Avançadas:</p>
                    <p className="uniqueTitle">{title}</p>
                  </>
                ) : (
                  <p>{title}</p>
                )}
                <IconDiv
                  onClick={(event) => {
                    event.stopPropagation();
                    setOpen(true);
                  }}
                >
                  {editable ? <EditIcon /> : null}
                </IconDiv>
              </>
            ) : (
              <Input
                ref={wrapperRef}
                maxLength="40"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                onKeyPress={handleKeyDown}
              />
            )}
          </ProjectName>
        </ContentName>

        {flow.versions.length > 0 ? (
          <>
            <VerticalLine />
            <DropSelect loadflow={loadflow} setCritical={setCritical} />
          </>
        ) : null}
      </Container>
  );
};

export default DropSelectVersion;
